import { ViewLayoutPlacement } from '@faire/web-api--source/indigofair/data/ViewLayoutPlacement';

export namespace ICategoryPageLayoutRequest {
  export enum PageType {
    PAGE_TYPE_UNKNOWN = 'PAGE_TYPE_UNKNOWN',
    NORMAL_CATEGORY_PAGE = 'NORMAL_CATEGORY_PAGE',
    NEW_BRAND_PAGE = 'NEW_BRAND_PAGE',
    NEW_PRODUCT_PAGE = 'NEW_PRODUCT_PAGE',
    PREORDER_MARKETPLACE = 'PREORDER_MARKETPLACE',
    /**
     * @deprecated
     */
    PREORDER_PRODUCT = 'PREORDER_PRODUCT',
    PLUS_SIZE_PAGE = 'PLUS_SIZE_PAGE',
    /**
     * @deprecated
     */
    FAIRE_SPECIALS_PAGE = 'FAIRE_SPECIALS_PAGE',
    PREORDER_PAGE = 'PREORDER_PAGE',
  }

  /**
   * Return an instance of ICategoryPageLayoutRequest with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<ICategoryPageLayoutRequest>
  ): ICategoryPageLayoutRequest =>
    ({
      filter_keys: [],
      ...(partial ?? {}),
    }) as ICategoryPageLayoutRequest;
}

export interface ICategoryPageLayoutRequest {
  path_identifier: string | undefined;
  filter_keys: Array<string>;
  /**
   * This is used to differentiate category pages.
   * Layout can be different depending on the pageType
   */
  page_type: keyof typeof ICategoryPageLayoutRequest.PageType | undefined;
  /**
   * Limits the number of LayoutElement.layoutElementData to return.
   */
  layout_elements_data_limit: number | undefined;
  /**
   * Product token used for highlighting the broad intent carousel experiment
   */
  highlighted_product_token: string | undefined;
  is_mobile_web: boolean | undefined;
  /**
   * This is the URL path that represents the category.
   */
  navigation_path: string | undefined;
  return_retrieval_and_ranking_debug_info: boolean | undefined;
  view_layout_placement: keyof typeof ViewLayoutPlacement | undefined;
}
